// extracted by mini-css-extract-plugin
export default {"root":"style_root__2S+gT","header":"style_header__nEaD5","content":"style_content__H4h5L"};